module.exports = __webpack_public_path__ + "img/Sylva_island.25cf6c67.png";